import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/categories', label: '分类浏览' },
  { to: '/articles', label: '精选文章' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <span className={`font-heading text-xl md:text-2xl font-semibold tracking-wide whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-white'
            }`}>
              亚洲精品
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to
                    ? scrolled || !isHome ? 'text-primary-600' : 'text-white font-semibold'
                    : scrolled || !isHome ? 'text-foreground-600 hover:text-foreground-900' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled || !isHome ? 'hover:bg-background-200 text-foreground-700' : 'hover:bg-white/10 text-white'
            }`}>
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled || !isHome ? 'hover:bg-background-200 text-foreground-700' : 'hover:bg-white/10 text-white'
            }`}>
              <i className="ri-user-3-line text-lg"></i>
            </button>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}